export default {
  northern: 'Northern',
  central: 'Central',
  southern: 'Southern',
  eastern: 'Eastern',
  island: 'Island',
  overseas: 'Overseas',
  isRequired: 'Is required.',
  submitSuccess: 'Success',
  detail: 'Learn More',
  partners: 'OwlTing Blockchain Services™ Partners',
  caseStudy: 'Customer Success Stories',
  freeTrial: 'Start Free Trial',
  contactAndBuy: 'Buy & Contact Us',
  language: 'Language',
  aboutUs: 'About Us',
  contactUs: 'Contact Us',
  submit: 'Submit',
  blockChainDiscovery: 'Explore Our Solutions',
  blockChainBenefits: 'Benefits',
  achieveMore: 'Achieve More with OwlTing Blockchain Services™',
  customerService: 'Customer Service',
  mailService: 'Mail Us',
  spotlight: 'Partner Spotlight',
  nav: {
    industries: 'Solutions by Industry',
    contactUs: 'Contact Us'
  },
  hero: {
    title: 'Solve business pain points today',
    mobileTitle: ['Solve business pain points today', ''],
    description: 'Use OwlTing Blockchain Services™ to boost your business with greater transparency and security'
  },
  form: {
    title: 'Let us know how to reach you and we\'ll be in touch shortly',
    companyName: 'Company Name',
    industry: 'Industry',
    name: 'Name',
    phone: 'Phone Number',
    email: 'E-mail Address',
    description: 'Description',
    plan: 'Plan',
    IOTs: 'IOTs'
  },
  banner: {
    title: 'Become an OwlTing Blockchain Services™ Partner',
    description: 'Ready to transform your business? Register now'
  },
  cookie: {
    title: 'User privacy statement',
    content: 'We use cookies to help give you the best experience on our website. By continuing without changing your cookie settings, we assume you agree to this. Please read our cookie policy to find out more.',
    more: 'Learn More',
    agree: 'Got it'
  },
  custom: {
    forestry: {
      title: 'Forestry Bureau, COA, Executive Yuan x OwlTing Blockchain Services™ Forest Products Traceability System',
      subTitle: 'The World\'s first Blockchain Forest Products Traceability System is officially online!',
      content: 'To improve validation of domestic timber and prevent illegal logging, the Taiwan Forestry Bureau announced Taiwanese Forest Products Traceability System on 2019/12/5, adopting blockchain technology as the solution.\n\n The Bureau collaborated with OwlTing Group, using blockchain’s traceable, immutable, and decentralized features to record the production process of forestry products. This will protect the rights of both lumber producers and customers, and this is also the world’s first blockchain traceability system for domestic lumber and bamboo products.',
      blockTitle: {
        product: 'Product Launch Press Conference',
        news: 'Media Coverage'
      }
    }
  },
  priceTable: {
    Agriculture: {
      projectPrice: 'Pricing Plans',
      tab01: 'Traceability Plan',
      tab02: 'IoT device',
      tab02Title: 'IoT device (outright purchase or leasing plan)',
      monthlyLeasing: '*For the monthly leasing plan, please note that the contract will be valid for at least 1 year.',
      annotation: '*Above pricing applies to global market (excluding Taiwan)'
    }
  },
  cases: {
    riceValley: {
      name: 'Chishang HeGuFang',
      intro: 'A brand that gives you comfort and reliance',
      product: 'Pesticide-free pearl white rice / brown rice'
    },
    passionFruit: {
      name: 'Taitung Passion Fruit',
      intro: 'Environmentally friendly & pesticide-free',
      product: 'Pesticide-free passion fruit'
    },
    oneForTea: {
      name: 'ONE for TEA',
      intro: 'Taitung Luye non-toxic tea garden',
      product: 'Red oolong tea/Yingxiang baozhong tea'
    },
    changbinRice: {
      name: 'Changbin Rice Long Shiu',
      intro: 'Grow with care, eat at ease',
      product: 'Organic white rice'
    },
    btn: 'Go to product traceability page'
  }
}
